<template>
  <div class="px-3 py-3 mb-5 col-24">
    <CreateCredentialProgram
      @closeModal="closeModalCredential"
      @updateWhiteList="atualizeWhiteList"
      v-if="id && showModal"
      :type="typeCredential"
      :idProgram="id"
      :idHacker="idHacker"
      :hackerName="hackerName"
    />
    <div class="col d-column">
      <h1 class="title pt-2 mb-0" v-text="$ml.get('credentials')">
        Credenciais
      </h1>

      <h1 class="title">
        <span class="pb-2" v-text="$ml.get('manageCredentials')"
          >Gerencie as credencias cadastradas.</span
        >
      </h1>

      <div class="row justify-content-between">
        <div class="card mb-3 col-sm-24 col-md mr-2">
          <div
            class="card-header-custom d-flex align-items-center justify-content-between"
          >
            <h6
              class="m-0 p-0 light col-10"
              v-text="$ml.get('programSpellers')"
            >
              Especialistas do programa
            </h6>
            <div
              class="input-group align-items-center d-flex justify-content-end"
            >
              <input
                class="form-control filterInput col-8"
                v-model="whiteListQuerySearch"
                :placeholder="$ml.get('search')"
                aria-label="Search"
                style="border-right: none"
                @input="waitAPI"
              />
              <div class="input-group-append">
                <div class="input-group-text" style="background-color: #fff">
                  <svg width="20" height="20" class="mt-1">
                    <image
                      xlink:href="../../../assets/icons/search_s.svg"
                      width="18"
                      height="18"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div
              class="col-1 d-flex justify-content-end"
              v-b-modal.modal-create-credential
              @click="(typeCredential = 'general'), (showModal = true)"
            >
              <VueCustomTooltip
                :label="$ml.get('manageYourCredentialsTooltip')"
              >
                <svg width="20" height="20">
                  <image
                    xlink:href="../../../assets/svg/globe-fill.svg"
                    width="20"
                    height="20"
                  />
                </svg>
              </VueCustomTooltip>
            </div>
          </div>

          <div class="card-body p-0">
            <table>
              <tbody>
                <div class="loading d-flex">
                  <div v-if="loadingWhitelist" class="c-loader my-2"></div>

                  <h6
                    v-else
                    v-show="!whitelist.length"
                    v-text="$ml.get('noExpertsFound')"
                    class="p-3 mt-2"
                  >
                    Nenhum especialista encontrado
                  </h6>
                </div>

                <div v-if="!loadingWhitelist">
                  <div v-for="(item, index) in whitelist" :key="index + 'role'">
                    <tr
                      class="d-flex justify-content-between align-items-center"
                    >
                      <td
                        :class="
                          program.vpn_required ? 'col-12 mt-1' : 'col-18 mt-1'
                        "
                      >
                        <strong v-text="item.username || item.email"></strong>
                      </td>
                      <td
                        class="row col-5 d-flex align-items-start justify-content-end"
                      >
                        <div
                          class="pl-0 pointer mx-1"
                          v-b-modal.modal-create-credential
                          @click="
                            (idHacker = item.person_id),
                              (hackerName = item.username),
                              (typeCredential = 'individual'),
                              (showModal = true)
                          "
                        >
                          <VueCustomTooltip
                            v-if="item?.has_credentials"
                            :label="$ml.get('manageYourCredentialsTooltip')"
                          >
                            <svg width="20" height="20">
                              <image
                                xlink:href="../../../assets/svg/key-fill.svg"
                                width="20"
                                height="20"
                              />
                            </svg>
                          </VueCustomTooltip>

                          <VueCustomTooltip
                            v-else
                            :label="$ml.get('createCredentialTooltip')"
                          >
                            <svg width="20" height="20">
                              <image
                                xlink:href="../../../assets/svg/key-fill-disable.svg"
                                width="20"
                                height="20"
                              />
                            </svg>
                          </VueCustomTooltip>
                        </div>
                      </td>
                    </tr>
                  </div>
                  <div
                    v-show="totalWhiteListPages > 10 && !loadingWhitelist"
                    class="p-3"
                  >
                    <b-pagination
                      v-model="whiteListAtualPage"
                      :total-rows="totalWhiteListPages"
                      :per-page="10"
                      :prev-text="$ml.get('previous')"
                      :next-text="$ml.get('next')"
                      align="right"
                    ></b-pagination>
                  </div>
                </div>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import CreateCredentialProgram from "../../../components/modais/CreateCredentialProgram.vue";
import ProgramService from "../../../services/program.service";
import _ from "lodash";
export default {
  name: "CrentialHacker",
  props: {
    program: {
      type: Object,
      required: true,
    },
  },
  components: {
    CreateCredentialProgram,
  },
  data() {
    return {
      showModal: false,

      idHacker: "",
      hackerName: "",

      id: "",

      blacklist: [],

      whitelist: [],

      totalWhiteListPages: 0,

      whiteListPageSize: 0,

      whiteListAtualPage: 1,

      whiteListQuerySearch: "",

      userEmail: "",
      emailError: false,

      loadingWhitelist: true,
      loadingBlacklist: true,

      online: false,

      typeCredential: "",
    };
  },

  mounted() {
    this.id = this.$route.fullPath.split("?")[1];
    this.atualizeWhiteList();
  },

  watch: {
    whiteListAtualPage: function () {
      this.atualizeWhiteList();
    },
  },

  methods: {
    waitAPI: _.debounce(function () {
      this.atualizeWhiteList();
    }, 500),

    closeModalCredential() {
      this.showModal = false;
    },

    atualizeWhiteList() {
      this.loadingWhitelist = true;
      this.whitelist = [];
      ProgramService.getProgramWhiteList(
        this.program.id,
        this.whiteListAtualPage,
        10,
        this.whiteListQuerySearch
      ).then(({ data }) => {
        this.whitelist = data.items;
        this.totalWhiteListPages = data.total;
        this.whiteListPageSize = data.pageSize;
        this.loadingWhitelist = false;
      });
    },

    unBlockHacker(id_hacker) {
      const self = this;
      Swal.fire({
        title: self.$ml.get("sureRemoveExpertBlacklist"),
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        customClass: {
          cancelButton: "btn-outline-extra",
        },
        confirmButtonText: "Remover",
        cancelButtonText: self.$ml.get("cancel"),
      }).then((result) => {
        if (result.value) {
          self.blacklist = [];
          self.whitelist = [];
          self.loading = true;

          ProgramService.putAccessHacker(
            this.program.id,
            "unblock",
            id_hacker
          ).then(
            () => {
              self.atualizeWhiteList();
            },
            () => {
              self.loading = false;
            }
          );
        }
      });
    },

    toogleVpnStatus(personId, action) {
      const self = this;

      ProgramService.putVpnHacker(this.program.id, personId, action)
        .then(() => {
          self.atualizeWhiteList();
          self.loading = false;
        })
        .catch((err) => {
          console.dir(err);
        });
    },
  },
};
</script>

<style scoped>
.statusVpn {
  color: #730ba9;
  padding: 6px;
  font-weight: 500;
  font-size: 12px;
}
.msgn {
  color: #730ba9;
}
.remove {
  background-color: rgba(241, 65, 65, 0.03);
}
.description-btn {
  max-width: 640px;
  display: block;
  font-size: 1rem;
  color: rgb(125, 133, 142);
  font-weight: 400;
}
.card-header-custom {
  background: #f7f8f9;
  font-weight: normal;
  font-style: normal;
  border-radius: 3px 3px 0 0;
  padding: 16px;
  border-bottom: 1px solid #edf2f9;
}
</style>
